export var convertToTimezone = function convertToTimezone(tz) {
  return function (date) {
    return new Date(date.toLocaleString('en-US', {
      timeZone: tz
    }));
  };
};